import React from 'react';
import './Speakers.css';
import VideoPresent from './VideoPresent/VideoPresent';
import Ruffieux from '../../img/speakers/Ruffieux.png'
import Shechter from '../../img/speakers/Shechter.png'
import eladsc from '../../img/speakers/eladsc.png'
import Kaufman from '../../img/speakers/Kaufman.png'
import NextInsurance from '../../img/speakers/Next Insurance.png'
import JobCloud from '../../img/speakers/JobCloud AG.png'
import Radzio from '../../img/speakers/Radzio.png'
import Cobiro from '../../img/speakers/Cobiro.png'
import Salnikov from '../../img/speakers/Salnikov.png'
import Microsoft from '../../img/speakers/Microsoft.png'
import PushBased from '../../img/speakers/PushBased.png'
import Hladky from '../../img/speakers/Hladky.png'
import GOOGLE from '../../img/speakers/GOOGLE.png'
import BabayAdi from '../../img/speakers/Babay-Adi.png'
import Gosebrink from '../../img/speakers/Gosebrink.png'
import Bampakos from '../../img/speakers/Bampakos.png'
import NA from '../../img/speakers/NA.png'
import Yadav from '../../img/speakers/Yadav.png'
import ANGULARarchitects from '../../img/speakers/ANGULARarchitects.png'
import Steyer from '../../img/speakers/Steyer.png'
import Plexscape from '../../img/speakers/Plexscape.png'
import OfferingSolutionsSoftware from '../../img/speakers/Offering Solutions Software.png'
import Stanimiroviс from '../../img/speakers/Stanimiroviс.png'
import Romaniak from '../../img/speakers/Romaniak.png'
import Aimtraction from '../../img/speakers/Aimtraction.png'
import Tayade from '../../img/speakers/Tayade.png'
import EmbarkingOnVoyage from '../../img/speakers/EmbarkingOnVoyage.png'
import Janca from '../../img/speakers/Janca.png'
import Purple from '../../img/speakers/We Hack Purple.png'
import Roberts from '../../img/speakers/Roberts.png'
import Appwrite from '../../img/speakers/Appwrite.png'
import Yusuf from '../../img/speakers/Yusuf.png'
import Haibrid from '../../img/speakers/Haibrid.png'
import Rani from '../../img/speakers/Rani.png'
import Samsung from '../../img/speakers/Samsung Research.png'
import Zohar from '../../img/speakers/Zohar.png'
import Shevchuk from '../../img/speakers/Shevchuk.png'
import Amazon from '../../img/speakers/Amazon.png'
import Rank from '../../img/speakers/Rank.png'
import ITHTechnologies from '../../img/speakers/ITH Technologies.png'
import Honcharuk from '../../img/speakers/Honcharuk.png'
import Cynet from '../../img/speakers/Cynet.png'
import Jha from '../../img/speakers/Jha.png'
import Patna from '../../img/speakers/National Institute of Technology Patna.png'
import Hussain from '../../img/speakers/Hussain.png'
import Fluin from '../../img/speakers/Fluin.png'
import Chainlink from '../../img/speakers/Chainlink Labs.png'
import Ghosh from '../../img/speakers/Ghosh.png'
import MicrosoftIEEEIBM from '../../img/speakers/Microsoft IEEE IBM.png'
import m4dz from '../../img/speakers/m4dz.png'
import RIOTS from '../../img/speakers/RIOTS.png'
import Kiss from '../../img/speakers/Kiss.png'
import Akinjiola from '../../img/speakers/Akinjiola.png'
import PayPal from '../../img/speakers/PayPal.png'

export default class SpeakersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    id: 7,
                    track: 'Junior',
                    photo: Salnikov,
                    name: 'Maxim Salnikov',
                    position: 'Developer Engagement Lead',
                    ln: 'https://www.linkedin.com/in/webmax/',
                    tw: 'https://twitter.com/webmaxru',
                    logo: Microsoft,
                    title: 'Sending the Angular app into deep, deep offline with Workbox',
                    abstract: `There is no need to advocate for progressive web apps anymore. The idea of connection-independent applications has proven its viability and we see more and more large and small projects following that path, making the offline-ready behavior a best practice, good manner of the web. In my session, based on the deep exploration of Service Worker API possibilities and gathered UX gotchas, we go through the history of the offline web, the importance of treating the network as an enhancement, current challenges (and their solutions) and proper tooling. We architect our offline-ready Angular app applying the best tech and UX practices adding the features one-by-one: app shell, caching resources and data, sync when online. All in name of our users who demand the new level of the resilient web experience.`,
                },
                {
                    id: 1,
                    track: 'Pro',
                    photo: Ruffieux,
                    name: 'Michel Ruffieux',
                    position: 'Lead Software Engineer',
                    ln: 'https://www.linkedin.com/in/mruffieux/',
                    tw: 'https://twitter.com/codepawn,',
                    github: 'https://github.com/mruffieux',
                    logo: JobCloud,
                    title: 'The microfrontend paradox',
                    abstract: `Does microfrontends really exist? The more I've been using this "architecture style", the more it became absurd to me. During this talk, I will present a fully working application using different frontends but you will never think of them as a microfrontends. At the end of this talk, you will resolve the microfrontend paradox using the Federated Architecture Strategy (FAS), you will understand the principles of FAS, the best practices and come out a lot less confused about was is often known as microfrontends`,
                },
                {
                    id: 2,
                    track: 'Pro',
                    photo: Shechter,
                    name: 'Elad Shechter',
                    position: 'CSS/HTML Architect',
                    tw: 'https://twitter.com/eladsc',
                    logo: eladsc,
                    title: 'Tips, Tricks, and New things in CSS',
                    abstract: `CSS has evolved a lot over the years, with many new features, which can help us work a lot easier. Elad Shechter, which eats and drinks CSS, will show you what amazing things you missed in CSS!`,
                },
                {
                    id: 5,
                    track: 'Junior',
                    photo: Kaufman,
                    name: 'Nir Kaufman',
                    position: 'Front End Tech Lead',
                    website: 'https://nir.life/',
                    logo: NextInsurance,
                    title: 'Keep it Simple! (with Angular)',
                    abstract: `Angular is a rich framework, loaded with everything we need in order to build single page applications (and beyond). But not every application need everything Angular got to offer..
                    In this session, we will learn how to keep things simple in Angular, and boost our productivity!`,
                },
                {
                    id: 11,
                    track: 'Junior',
                    photo: BabayAdi,
                    name: 'Hava Babay-Adi',
                    position: 'Tech Lead',
                    ln: 'https://www.linkedin.com/in/havababay/',
                    logo: GOOGLE,
                    title: 'Guidelines for Developing UI Components',
                    abstract: `When one thinks about UI development, implementing user experience and applying the graphic design for the application comes to mind. However UI development is also about software engineering, and designing an architecture for a web application, that will allow engineers to extend and maintain it effectively.
    
                    In this talk, I’ll share guidelines and best practices for designing, developing, and maintaining UI components and their hierarchy. Those guidelines are lessons I’ve learnt from my experience of the past 2 years in which I’ve been developing and maintaining a complex UI module. In order to demonstrate these principles we’ll use a sample web application and apply the guidelines while examining their effect.`,
                },
                {
                    id: 6,
                    track: 'Pro',
                    photo: Radzio,
                    name: 'Greg Radzio',
                    position: 'CTO',
                    ln: 'https://www.linkedin.com/in/greg-radzio-58aa046b/',
                    tw: 'https://twitter.com/gregradzio',
                    github: 'https://github.com/gradzio',
                    website: 'https://medium.com/@gregradzio',
                    yb: 'https://www.youtube.com/c/GregRadzio ',
                    logo: Cobiro,
                    title: 'Ship like a Boss with Feature Flags',
                    abstract: `Is a release a big event in your company? Do you have to allocate extra time for each feature just to resolve merge conflicts on git? After this session, this will become history. I will show you how can you use feature flags and Continuous Delivery methodologies in order to reduce your time to market, pain related to merging and deliver faster and with less errors. As a bonus you will also learn how to make your angular components have multiple versions in production and enable your business to use A/B testing. All this in combination with open source package that we have build and you can start using it too! All this using the best JS framework out there - Angular!`,
                },
          ],
          listHide: [
            {
                id: 8,
                track: 'Pro',
                photo: Hladky,
                name: 'Michael Hladky',
                position: 'CEO of Hladky IT consulting GmbH and Push-Based',
                ln: 'https://www.linkedin.com/in/michael-hladky-519340148/ ',
                tw: 'https://twitter.com/Michael_Hladky',
                github: 'https://github.com/BioPhoton?tab=overview&from=2021-08-01&to=2021-08-25',
                logo: PushBased,
                title: 'Performance at scale',
                abstract: `This talk will feature the most up-to-date information to expand your knowledge of performance optimization techniques beyond the basics. In the end, you will go home with lots of exercises to guide you and a wealth of insights to work with, impressed by how much faster your application can get.
                Together we will take a closer look at what an auditing process looks like. Then, we will discuss how to read Flame Charts, learn how to navigate through the network tab, and increase our knowledge of network analysis features. Finally, we will take a spin on the brand-new Angular Performance DevTools and compare them with the original ChromeDevTools.`,
            },
            {
                id: 9,
                track: 'Junior',
                photo: Gosebrink,
                name: 'Fabian Gosebrink',
                position: 'Technical Lead',
                tw: 'https://twitter.com/fabiangosebrink',
                logo: OfferingSolutionsSoftware,
                title: 'Angular Architectures with NgRx Stores & Effects',
                abstract: `Angular offers you nearly endless possibilities in frontend, but with great power comes great responsibility. If an application grows, we sooner or later have to face the question of state management on client side. But what is a state exactly? And what does "stateful" and "stateless" mean? And how can I manage the state of my application in a nice and clean way? Tools like NgRx with stores and effects can help us to design our application in a very lightweight and beautiful way. In this talk, Fabian Gosebrink will shed a light on how to use NgRx with stores and separate effects so that we do not have to fear big angular architectures again.`,
            },
            {
                id: 3,
                track: 'Junior',
                photo: Ruffieux,
                name: 'Michel Ruffieux',
                position: 'Senior software engineer',
                ln: 'https://www.linkedin.com/in/mruffieux/',
                tw: 'https://twitter.com/codepawn',
                github: 'https://github.com/mruffieux',
                logo: JobCloud,
                title: 'App federation: the real deal',
                abstract: `You've probably heard about all the hype around a concept, an architecture strategy called micro frontends. Unfortunately, some frontend may have absolutely nothing micro. Hence, micro frontend lose all its sense. I personally have been using this approach for over 2 years now and I would like to present to you the real mechanism behind the name and what it takes create a federated application using different frontends.`,
            },
            {
                id: 12,
                track: 'Pro',
                photo: Bampakos,
                name: 'Aristeidis Bampakos',
                position: 'Web Development Team Lead',
                ln: 'https://www.linkedin.com/in/aristeidisbampakos',
                tw: 'https://twitter.com/abampakos',
                github: 'https://github.com/bampakoa',
                website: 'https://medium.com/@abampakos',
                logo: Plexscape,
                title: 'Testing components with Angular CDK',
                abstract: `Whether you are using the Angular Material library or building a 3rd party component library by yourself, Angular CDK provides all the necessary infrastructure to help you test your components. In this talk, we will learn about the Angular CDK component harness, a mechanism that enables you to write robust, readable, and concise tests for your Angular components.`,
            },
            {
                id: 4,
                track: 'Pro',
                photo: Shechter,
                name: 'Elad Shechter',
                position: 'CSS/HTML Architect',
                tw: 'https://twitter.com/eladsc',
                logo: eladsc,
                title: 'The New CSS Logical Properties',
                abstract: `The new world in CSS will give you new abilities with this new technology to support all types of languages, like Hebrew / English / Japanese / Mongolian, without the need to make new styles!
                – Say Hello to the Axis World
                – Old World vs. New World
                – New CSS Logical Properties
                – How to Update Your Website with these New Properties
                – And More!`,
            },
            {
                id: 13,
                track: 'Pro',
                photo: Yadav,
                name: 'Santosh Yadav',
                position: 'Software Consultant',
                ln: 'https://www.linkedin.com/in/santoshyadavdev/',
                tw: 'https://twitter.com/SantoshYadavDev',
                github: 'https://github.com/santoshyadavdev',
                logo: NA,
                title: 'Creating and Publishing Angular Libraries Like a Pro with Nx',
                abstract: `Angular Libraries lets you create reusable code, which can be published on antifactory and distributed for all your Applications. Join me to learn how you can create and publish libraries like a Pro with the help on NxDevTools. Bonus you will learn, how you can configure Secondary Entrypoints to tree shake the unwanted code.`,
            },
            {
                id: 10,
                track: 'Pro',
                photo: Gosebrink,
                name: 'Fabian Gosebrink',
                position: 'Technical Lead',
                tw: 'https://twitter.com/fabiangosebrink',
                logo: OfferingSolutionsSoftware,
                title: 'Business Architectures with Angular Libraries, NX and Monorepos',
                abstract: `Angular is a great tool for creating applications with a big architecture in mind. It comes with benefits like Testing, Dependency Injection or Http Communication out of the box. But when your application grows and enlarges often a single Angular application comes unhandy and developer seem to lose the focus on where to put which feature. And after managing Angular's learning curve designing shared features or loosely couples fragments while developing an app seems to be a challenge still because having everything in one app seems not to be a well-structured architecture.
                In this talk Fabian Gosebrink will explain the power of Angular's architectural features and push them to the edge where the extraction of libraries and creating a complete workspace with tools like NX can safe you and help you to write clean large Angular applications, lovely shareable features and gets your Angular business application back into shape again. Because large angular apps don't have to be difficult to maintain.`,
            },
            {
                id: 14,
                track: 'Pro',
                photo: Steyer,
                name: 'Manfred Steyer',
                position: 'Trainer, Consultant, Programming Architect',
                tw: 'https://twitter.com/ManfredSteyer',
                logo: ANGULARarchitects,
                title: 'Micro-Frontends with Module Federation: Beyond the Basics',
                abstract: `Being the missing link for Micro-Frontends, the brand-new Module Federation has been greatly discussed in recent months.

                However, once the basics have been mastered, the truly interesting questions arise: How do you deal with version mismatches? How do you load remotes dynamically when you do not know them or even their number upfront? How do you use Module Federation in a monorepo? How do you use Module Federation together with Web Components for multi-version and/or multi-framework scenarios?
                
                This session answers all these questions with a case study and explores the trade-offs. By the end, you will know how to apply this to your projects.`,
            },
            {
                id: 15,
                track: 'Pro',
                photo: Stanimiroviс,
                name: 'Marko Stanimirović',
                position: 'Senior Frontend Developer',
                ln: 'https://www.linkedin.com/in/markostanimirovic/',
                tw: 'https://twitter.com/MarkoStDev',
                github: 'https://github.com/markostanimirovic',
                website: 'https://dev.to/markostanimirovic',
                logo: JobCloud,
                title: 'NgRx Tips for Future-Proof Angular Apps',
                abstract: `In this talk, we will walk through the frequent NgRx pitfalls and see ways to avoid them. By applying these tips, you will be able to increase code quality, performance, and maintainability in Angular applications that use NgRx as a global state management solution.`,
            },
            {
                id: 16,
                track: 'Pro',
                photo: Romaniak,
                name: 'Oleksandr Romaniak',
                position: 'Founder / CTO',
                ln: 'https://www.linkedin.com/in/romaniak-alexander/',
                logo: Aimtraction,
                title: 'Why Angular 12 is way faster than its JS competitors.',
                abstract: `1. Time to market or optimization. Is it possible to achieve both?
                2. What to tune and where to optimize the Angular to make it faster. 
                3. Pros and cons about early optimization.
                4. How Google search algorithm force Angular to improve overall performance.
                5. To be or not to be. Does speed matter for faster development, or flexibility with a unified approach is more desirable?`,
            },
            {
                id: 17,
                track: 'Pro',
                photo: Tayade,
                name: 'Pankaj Tayade',
                position: 'Engineering Lead',
                ln: 'https://www.linkedin.com/in/pankaj-tayade-b74b0a59/',
                logo: EmbarkingOnVoyage,
                title: 'Angular 2030',
                abstract: `I would like to share how JavaScript landscape is changing and until 2030 the complete concept will undergo a major transformation.`,
            },
            {
                id: 18,
                track: 'Junior',
                photo: Janca,
                name: 'Tanya Janca',
                position: 'CEO and Founder',
                tw: 'https://twitter.com/shehackspurple',
                website: 'https://shehackspurple.ca', 
                yb: 'https://www.youtube.com/shehackspurple',
                website1: 'https://newsletter.shehackspurple.ca',
                website2: 'https://AliceandBobLearn.com',
                ln: 'https://www.linkedin.com/in/tanya-janca',
                inst: 'https://www.instagram.com/shehackspurple/',
                fb: 'https://www.facebook.com/tanya.janca/',
                logo: Purple,
                title: 'Pushing Left, Like a Boss',
                abstract: `With security incidents and penetration testing currently receiving most of our application security dollars, it would appear that industry has decided to treat the symptom instead of the disease.  “Pushing left” refers to starting security earlier in the SDLC; addressing the problem throughout the process.  From scanning your code with a vulnerability scanner to red team exercises, developer education programs and bug bounties, this talk will show you how to ‘push left', like a boss.`,
            },
            {
                id: 19,
                track: 'Pro',
                photo: Roberts,
                name: 'Brandon Roberts',
                position: 'DevRel Engineer',
                tw: 'https://twitter.com/brandontroberts',
                github: 'https://github.com/brandonroberts',
                logo: Appwrite,
                title: 'State Management at Scale with NgRx',
                abstract: `NgRx provides Angular developers a framework for managing your application state in a reactive way. It also presents developers with opportunities to use it in different ways, whether it be with global state or local state. This flexibility can also lead to questions about which path to take when building with NgRx. This talk aims to answer some of the questions of how to effectively use NgRx for state management in your Angular application.`,
            },
            {
                id: 20,
                track: 'Pro',
                photo: Kaufman,
                name: 'Nir Kaufman',
                position: 'Front End Tech Lead',
                website: 'https://nir.life/',
                logo: NextInsurance,
                title: 'Advanced DOM Manipulation in Angular',
                abstract: `In this session, we will implement an advanced directive from scratch and learn some practical techniques for advanced DOM manipulation.`,
            },
            {
                id: 21,
                track: 'Junior',
                photo: Yusuf,
                name: 'Sani Yusuf',
                position: 'Founder',
                tw: 'https://twitter.com/saniyusuf',
                ln: 'https://www.linkedin.com/in/saniyusuf/',
                logo: Haibrid,
                title: 'Differential Loading',
                abstract: `Creating applications that serve users from near and far can be challenging. There are endless things you have to try to normalise across the board. To mention a few you have to watch out for Browser support, accessibly to name a few. It is impossible to make a perfect application but sometimes, especially when we want to use modern JS features.

                Polyfills are great but sometimes, they do add extra payload for the users that do not need the polyfills in the first place. Angular's built-in Differential loading helps us achieve an automated way of ensuring that users only get a build that includes only the tools they need and nothing more.`,
            },
            {
                id: 22,
                track: 'Pro',
                photo: Rani,
                name: 'Steffi Keran Rani',
                position: 'Lead Engineer',
                tw: 'https://twitter.com/steffikeranj',
                ln: 'https://www.linkedin.com/in/steffi-keran-rani-j/',
                website: 'https://stackoverflow.com/users/7245145/steffi-keran-rani-j',
                logo: Samsung,
                title: 'Reactive State Management with NgRx',
                abstract: `Data in Angular applications is usually fetched and maintained in the service layer of Angular Application. But when your Angular application grows in features, it becomes hard to maintain a single source of truth for your data, difficult to maintain and this can impediment the development process as well. With tools like NgRx, you can have unidirectional data flow, and single source of truth for your entire Angular application. In this talk, we will learn  how NgRx works, key concepts of NgRx, how NgRx will be advantageous for your Angular development, and how you can leverage the libraries of NgRx for building reactive state applications in Angular.`,
            },
            {
                id: 23,
                track: 'Pro',
                photo: Zohar,
                name: 'Nitsan Zohar',
                position: 'Fronend Tech Lead',
                ln: 'https://www.linkedin.com/in/nitsan-zohar/',
                logo: NextInsurance,
                title: 'Dockerize Your Angular App',
                abstract: `How to write a multi-stage dockerfile to build an angular application using docker without the DevOps team.`,
            },
            {
                id: 24,
                track: 'Pro',
                photo: Shevchuk,
                name: 'Vitalii Shevchuk',
                position: 'Senior Frontend Developer',
                tw: 'https://twitter.com/easy_web_org',
                website: 'https://easy-web.medium.com', 
                ln: 'https://www.linkedin.com/in/vitalii-shevchuk-86389a112',
                fb: 'https://www.facebook.com/easyweb.org',
                logo: Amazon,
                title: 'State management between Angular Micro Frontend applications',
                abstract: `The first part is about the challenges of implementing Micro Frontend. Then focus on sharing the state between micro applications. And finally, showing the demo how to implement it using Angular, NX, NgRx`,
            },
            {
                id: 25,
                track: 'Junior',
                photo: Rank,
                name: 'Jay Rank',
                position: 'Full Stack Blockchain Developer',
                tw: 'https://twitter.com/RankJay1',
                github: 'https://github.com/RankJay', 
                ln: 'https://www.linkedin.com/in/rankjay/',
                logo: ITHTechnologies,
                title: 'Applications of Angular in Web 3.0',
                abstract: `Angular JS for Web3, Applications of Web3, Frameworks to use for Web3, Building a simple DApp using Angular`,
            },
            {
                id: 26,
                track: 'Junior',
                photo: Honcharuk,
                name: 'Vitalii Honcharuk',
                position: 'Team Lead & Principal Software Engineer',
                github: 'https://github.com/vit-h', 
                logo: Cynet,
                title: 'Angular Typescript API Client from OpenApi or Swagger with ease',
                abstract: `Masterclass`,
            },
            {
                id: 27,
                track: 'Junior',
                photo: Jha,
                name: 'Manvi Jha',
                position: 'Student',
                website: 'https://manvijha.netlify.app/',
                github: 'https://github.com/Severus-Matthew', 
                ln: 'https://www.linkedin.com/in/manvi-jha-2784711a7/',
                logo: Patna,
                title: 'Angular13 - A quick Walkthrough',
                abstract: `The new version of Angular has been released towards the end of 2021. While there were endless contributions made to angular by developers across the globe, angular added a few of them to release an enhanced version of the framework. The recent version facilitates the development of various projects through many aspects.

                In this talk, I'll take the audience on a walkthrough of the latest and significant updates of angular in its new version. The talk will consist of discussions and live demonstrations of the latest features ranging from support for typescript 4.4 to the new type of forms. All the updates like ergonomic APIs, Angular CLI enhancements, APF changes etc will be covered.`,
            },
            {
                id: 28,
                track: 'Pro',
                photo: Hussain,
                name: 'Saddam Hussain',
                position: 'Angular Frontend Developer',
                ln: 'https://www.linkedin.com/in/saddamnhussain/',
                title: 'Displaying data using CSS with Angular syntax',
                abstract: `I'll be showing the tips and tricks to maintain the UI with the data from the Backend and will display the best UI approach as we can.`,
            },
            {
                id: 29,
                track: 'Junior',
                photo: Fluin,
                name: 'Stephen Fluin',
                position: 'Head of Developer Relations',
                tw: 'https://twitter.com/stephenfluin',
                logo: Chainlink,
                title: 'Why You Should Update To Angular 13',
                abstract: `Updating your software to the latest version can be a bit of a pain. Major companies routinely fail to keep their software up to date, but you can do better! Learn about the reasons why you should keep your applications up to date, as well as some of the tools that will help you along the way.`,
            },
            {
                id: 30,
                track: 'Junior',
                photo: Ghosh,
                name: 'Ananya Ghosh',
                position: 'Beta Microsoft Learn Student Ambassador, Technical Head, IBM Z Ambassador',
                website: 'https://linktr.ee/A_GHOSH_dev',
                logo: MicrosoftIEEEIBM,
                title: 'Angular - Basics, New Features, Microservices and RxJs',
                abstract: `The talk will cover the following topics with details:

                1. Basics about Angular.
                2. New Features in Angular 13
                    2.1 Ivy-based features
                    2.2 Alterations to APF (Angular Package Format)
                    2.3 Improved Command Line Interface CLI
                    2.4 Updates in component API
                    2.5 Removing the support regarding IE11
                    2.6 Improved Angular tests
                    2.7 Angular Material
                3. Future of Angular
                4. Microservices , Routing, RxJS best practices
                5. Will try to give some hands on experience of coding.`,
            },
            {
                id: 31,
                track: 'Pro',
                photo: m4dz,
                name: 'm4dz 🎙🥑',
                position: 'Principal Developer Advocate',
                tw: 'https://twitter.com/m4d_z',
                ln: 'https://www.linkedin.com/in/m4d-z/',
                logo: RIOTS,
                title: 'The Mushin Way to Frontend Performance: Switch Left to a Pure Design System',
                abstract: `Have you ever imagined that your task as a User Interface Developer would one day become that complex? We had to support responsive design, and it was already difficult at some point. Truth is it was only the smallest of our daemons.

                It's 2022. We still have to address devices with very non-homogeneous screen sizes, but also very diverse SoC, performance variations, users prefs-based themes, network issues from Edge to 5G or WiFi. And the list will go on growing.
                
                Facing this, we can't continue to handle interfaces the way we did for the last years. We need to shift left, and burn into our Design Systems how to address configurations depending on the context. By moving the responsibility to the components level, we would be able to test, adapt, and deploy at scale complex interfaces without having to fear unexpected issues on some configurations.
                
                Here's how to proceed to build context-proof UI as an Interface Developer in 2022.`,
            },
            {
                id: 32,
                track: 'Pro',
                photo: Kiss,
                name: 'Marcell Kiss',
                position: 'CTO',
                tw: 'https://twitter.com/marcelltech',
                ln: 'https://www.linkedin.com/in/marcellkiss/',
                github: 'https://github.com/marcellkiss',
                title: 'Micro Frontends with @angular/elements',
                abstract: `In this talk, I'm summing up the experience of my last 3 years, I got at an InsureTech Enterprise.
                The talk consists of 3 parts: 
                - The project in general: why it made sense to apply Micro Frontends
                - What are Micro Frontends exactly. What are the benefits and difficulties?
                - Practical example of building Web Components with @angular/elements, with an OSS example.`,
            },
            {
                id: 33,
                track: 'Junior',
                photo: Akinjiola,
                name: 'Oluwatoni Akinjiola',
                position: 'Senior Software Engineer',
                tw: 'https://twitter.com/toni_x_coder',
                ln: 'https://www.linkedin.com/in/toni-akinjiola/',
                github: 'https://github.com/toniton',
                logo: PayPal,
                title: 'Accessibility in Angular, Removing Barriers',
                abstract: `There are about 1 billion people living with some form of disability or the other around the world. It is therefore significant to consider accessibility when building web applications using AngularJS, to ensure that more people are able to access your websites/application.

                Accessibility also ensures that existing users of a website/application are not disenfranchised from using the services provided by the developers of AngularJS.
                
                Focusing on accessibility when developing AngularJS application would help to develop better applications that are inclusive and easily accessible by all.
                
                In my talk, I would be spending some time on the common techniques and best practices that can be used in developing an Angular Website/Application with accessibility in focus.`,
            },
        ],
        }
    }

    render() {
        return (
            <div className="speakers" id='speakers'>
                <h3>Our speakers</h3>
                <VideoPresent speakers={this.state.list} speakersHide={this.state.listHide} />
            </div>
        );
    }
};